import { FormGroup } from '@angular/forms';
import { LabelValue } from '../models/label-value.model';

export class VehicleListValue {
  public QuoteId: number;
  public QuoteGuid: string;
  public ImageUrl: string;
  public Manufacturer: string;
  public Colour: string;
  public Model: string;
  public CapCodeId: string;
  public EngineSize: string;
  public Vrm: string;
  /**
 * @deprecated Use `RegLetter` instead.
 */
  public RegYear: string;
  public RegLetter: string;
  public CapCode: string;
  public Commercial: boolean;
  public DefaultVehicleImageUrl = '../../assets/images/unknownCar.png';
  public FuelType: string;
  public HasSalvage: boolean;
  public Form: FormGroup;
  public IsVan: boolean;
  public QuoteStateId?: number;

  constructor(vehicleLabelValueLists: LabelValue[], quoteId: number, quoteGuid: string, selectedFuelType: string, hasSalvage: boolean,  partialData?: Partial<VehicleListValue>) {
    const get = (label: string) =>
      vehicleLabelValueLists?.find(x => x.label === label)?.value || '';

    this.QuoteId = quoteId ?? 0;
    this.QuoteGuid = quoteGuid ?? '';
    this.FuelType = selectedFuelType ?? '';
    this.HasSalvage = hasSalvage ?? false;
    

    if (!this.ImageUrl) {
      this.ImageUrl = this.DefaultVehicleImageUrl;
    }

    if (vehicleLabelValueLists && vehicleLabelValueLists.length > 0) {
      this.Model = get('Model');
      this.Colour = get('Colour');
      this.Manufacturer = get('Manufacturer');
      this.ImageUrl = get('ImageUrl') || this.DefaultVehicleImageUrl;
      this.CapCodeId = get('GuideBookId');
      this.EngineSize = get('Engine Size');
      this.Vrm = get('Vrm');
      this.RegLetter = `${get('Year')}/${get('RegLetter')}`;
      this.CapCode = get('GuideBookCode');
      this.Commercial = get('Commercial') === 'True';
    }
    else if (partialData) {
      this.Model = partialData.Model ?? '';
      this.Colour = partialData.Colour ?? '';
      this.Manufacturer = partialData.Manufacturer ?? '';
      this.ImageUrl = partialData.ImageUrl || this.DefaultVehicleImageUrl;
      this.CapCodeId = partialData.CapCodeId ?? '';
      this.EngineSize = partialData.EngineSize ?? '';
      this.Vrm = partialData.Vrm ?? '';
      this.Form = partialData.Form;
      this.IsVan = partialData.IsVan ?? false;
      this.QuoteStateId = partialData.QuoteStateId ?? 0;
    }
  }
}
